import { fetchAuthSession } from "aws-amplify/auth";

const { API_BASE_URL } = window.APP_CONFIG;

let onUnauthorized = null;

export function setUnauthorizedHandler(handler) {
  onUnauthorized = handler;
}

async function request(path, options = {}) {
  const session = await fetchAuthSession();
  const idToken = session.tokens.idToken.toString();


  const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
  }

  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: headers,
  });

  // 🔥 ICI : interception globale
  if (res.status === 401) {
    console.warn("401 Unauthorized → logout");
    if (onUnauthorized) onUnauthorized();
    throw new Error("Unauthorized");
  }

  if (!res.ok) {
    throw new Error(`API error ${res.status}`);
  }

  return res.json();
}

export const api = {
  getCategories: () => request("/categories"),
  getQuizzesByCategory: (category) =>
    request(`/categories/${category}`),
  getQuiz: (quizId) =>
    request(`/quizzes/${quizId}`),
  submitQuiz: ({ quizId, answers }) =>
    request(`/quizzes/${quizId}/submit`, {
      method: "POST",
      body: JSON.stringify({ answers }),
    }),
};
